import type { JSX, PropsWithChildren } from 'react';
import { useState } from 'react';

import type { FormValues } from 'src/app/pages/petitionDetails/shared/types';

import { MobileSignFormContext } from './context';

export const MobileSignFormContextProvider = ({ children }: PropsWithChildren<EmptyProps>): JSX.Element => {
	const [mobileSignFormValues, setMobileSignFormValues] = useState<FormValues | undefined>(undefined);

	const updateMobileSignFormValues = (values: FormValues) => {
		setMobileSignFormValues(values);
	};

	return (
		<MobileSignFormContext.Provider value={{ mobileSignFormValues, updateMobileSignFormValues }}>
			{children}
		</MobileSignFormContext.Provider>
	);
};
